import React, { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";

import { useMastersContext } from "../../../../contexts/masters.context";
import globalValuesService from "../../../../services/globalValuesService";
import CrudTable from "../../shared/table/CrudTable";
import { TABLE_COLUMNS } from "./models/GlobalValuesTableColumns";

function GlobalValuesTable() {
  const {
    push,
    location: { pathname },
  } = useHistory();

  const { globalValuesState } = useMastersContext();

  useEffect(() => {
    globalValuesState.fetch();
  }, []);

  const columns = useMemo(() => TABLE_COLUMNS, [TABLE_COLUMNS]);
  const data = useMemo(() => globalValuesState.data || [], [
    globalValuesState.data,
  ]);

  const removeHandler = async (id) => {
    if (window.confirm("Are you sure ?") === true) {
      const result = await globalValuesService.remove(id);
      if (result.success === true) {
        globalValuesState.fetch();
      }
    }
  };

  // debugger
  return (
    <div>
      <div className="row">
        <div className="col"></div>
        <div className="col">
          <h4>Global Values</h4>
        </div>
        <div className="col d-flex justify-content-end">
          {/* <button
            className="btn btn-sm btn-success"
            onClick={() => push(`${pathname}/add`)}
          >
            Add New
          </button> */}
        </div>
      </div>
      <hr />
      <CrudTable
        loading={globalValuesState.loading}
        data={data}
        columns={columns}
        idField="columnName"
        onEdit={(id) => push(`${pathname}/edit/${id}`)}
        showDetails={false}
        showEdit={true}
        showRemove={false}
      />
    </div>
  );
}

export default GlobalValuesTable;
